import { UserTypes } from '@/legacy/common/constants';

/**
 * Gets path to offer details page based on the provided deal cycle id and user type.
 */
export const getOfferDetailsPagePath = (
  dealCycleId: string | number,
  userType: keyof typeof UserTypes = 'buyer',
) => (userType === 'seller' ? `/seller/offers/${dealCycleId}` : `/offers/${dealCycleId}`);
